<script setup lang="ts">
import { computed, type Component } from 'vue';
import {
  PhArrowRight,
  PhHeart,
  PhX,
  PhStar,
  PhCheck,
  PhSpinner,
} from '@phosphor-icons/vue';

type IconSource = Component | string | undefined;

const props = defineProps<{
  leadingIcon?: IconSource;
  trailingIcon?: IconSource;
  loading?: boolean;
  ariaHidden?: boolean;
  weight?: string;
}>();

const iconMap: Record<string, Component> = {
  PhArrowRight,
  PhHeart,
  PhX,
  PhStar,
  PhCheck,
  PhSpinner,
};

const resolveIcon = (icon: IconSource): Component | undefined => {
  if (!icon) {
    return undefined;
  }
  if (typeof icon !== 'string') {
    return icon;
  }
  return iconMap[icon];
};

const resolvedLeadingIcon = computed(() => resolveIcon(props.leadingIcon));
const resolvedTrailingIcon = computed(() => resolveIcon(props.trailingIcon));
const ariaHidden = computed(() => props.ariaHidden ?? true);
const weight = computed(() => props.weight ?? 'bold');
</script>

<template>
  <component
    v-if="resolvedLeadingIcon && !props.loading"
    :is="resolvedLeadingIcon"
    :aria-hidden="ariaHidden"
    :weight="weight"
  />
  <component
    v-if="resolvedTrailingIcon && !props.loading"
    :is="resolvedTrailingIcon"
    :aria-hidden="ariaHidden"
    :weight="weight"
  />
</template>
